import getConfig from 'next/config';
import {Hashes} from '~/src/utilities/constants/hash';

const {publicRuntimeConfig: config} = getConfig();
const hasProtocol = (url) => url.startsWith('http://') || url.startsWith('https://');

const rootPaths = {};
config.languages.forEach((languageKey, index) => (rootPaths[languageKey] = config.languagePaths[index]));

const getRootPath = (language = config.language) => rootPaths[language] || '/';

const createURL = (path, language = config.language) => {
    const urlPath = path || '';
    const rootPath = getRootPath(language);
    const pathSegments = [].concat(rootPath.split('/'), urlPath.split('/')).filter((item) => item);

    return `/${pathSegments.join('/')}`;
};

const getContentUrl = (url, anchor, language = config.language) => {
    if (url && hasProtocol(url)) {
        return url;
    }

    if (Object.values(Hashes).includes(anchor)) {
        return `${createURL(url, language)}#${anchor}`;
    }
    return createURL(url, language);
};

const getVideoUrl = (url) => {
    return getContentUrl(url.replace(/\/story\//, '/video/'));
};

const getFridayUrl = (language) => {
    const baseUrl = 'https://www.friday-magazine.ch';

    if (language !== 'de') {
        return `${baseUrl}/${language}`;
    }

    return baseUrl;
};

const getLematinUrl = () => 'https://lematin.ch';

const getRadioUrl = (language) => `https://20min.fm/playerv2/?player=${language}`;

const getCategoryUrl = (url) => {
    if (url === 'friday') {
        return getFridayUrl(config.language);
    }

    if (url === 'le-matin') {
        return getLematinUrl();
    }

    if (url === 'radio') {
        return getRadioUrl(config.language);
    }

    if (url && url === config.frontCategory) {
        url = '';
    }

    return createURL(url);
};

const getPageUrl = (url) => {
    return createURL(url);
};

const applyQuery = (sourceUrl, destinationUrl) => {
    const query = sourceUrl.split('?')[1];
    const anchor = !query && sourceUrl.split('#')[1];
    const destinationPath = destinationUrl.split('#')[0].split('?')[0];
    return `${destinationPath}${(query && '?' + query) || ''}${(anchor && '#' + anchor) || ''}`;
};

export {getRootPath, hasProtocol, getContentUrl, getVideoUrl, getCategoryUrl, getPageUrl, applyQuery};
